module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Fragebogen grün.23865e84.svg";